<template>
  <div class="teacher-gallery-grid__item">
    <modal
      v-model="modal.show"
      type="delete"
      title="Delete submission"
      @confirm="deleteSubmission(modal.submission)"
      @cancelled="modal.show = false"
    >
      Are you sure you want to delete this submission?
    </modal>

    <drag-drop-area
      v-if="item.critique && !item.critiqueUrl"
      v-model="upload.file"
      @update="uploadCritiqueHandler(item.id)"
      class="item__upload"
    >
      <span class="item__upload__label">Upload Critique</span>
    </drag-drop-area>

    <div class="item__actions">
      <a
        :href="item.critiqueUrl"
        target="_blank"
        rel="noreferrer"
        class="item__action item__critiqued"
        v-if="item.critiqueUrl"
      >
        <font-awesome-icon icon="check"></font-awesome-icon>
      </a>

      <a
        v-if="item.critique"
        class="item__action item__download"
        :href="item.url"
        download
      >
        <font-awesome-icon icon="download" />
      </a>
      <app-button
        @click.native="deleteHandler(item.id)"
        size="sm"
        v-if="showingDelete"
        >Delete</app-button
      >
    </div>

    <span class="author">
      {{ item.user.displayName || item.user.username }}
    </span>
    <img class="paintover-overlay" :src="item.critiqueUrl" alt="" />
    <img :src="item.thumbnail" alt="" @click="clickHandler(item)" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import maddyApi from '@/services/maddyApi';
import DragDropArea from '@/components/global/DragDropArea';

export default {
  name: 'gallery-item',
  props: ['item'],
  components: { DragDropArea },
  data: function() {
    return {
      modal: {
        show: false,
        submission: '',
      },
      upload: {
        file: null,
      },
    };
  },
  methods: {
    clickHandler(item) {
      this.$emit('openslide', item);
    },
    async uploadCritiqueHandler(id) {
      if (!this.upload.file) return;

      const endpoint = `/studies/${this.$route.params.id}/submission/${id}/paintover`;
      const data = new FormData();
      data.append('paintover', this.upload.file, +new Date());
      const options = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      };

      try {
        await maddyApi.post(endpoint, data, options);
        this.$emit('addPaintover');
      } catch (err) {
        // console.log(err);
      }
    },
    deleteHandler(id) {
      this.modal.show = true;
      this.modal.submission = id;
    },
    async deleteSubmission(id) {
      this.error = null;
      try {
        await maddyApi.delete(
          `/studies/${this.$route.params.id}/submission/${id}`,
        );
        await this.getGallery();
      } catch (err) {
        this.error = err;
      }
      this.modal.show = false;
      this.modal.submission = '';
      this.$emit('deleted', this.item.id);
    },
  },
  computed: {
    ...mapState('teacher', {
      showingDelete: state => state.filter.showingDelete,
    }),
  },
};
</script>

<style lang="scss" scoped>
.teacher-gallery-grid__item {
  position: relative;
  cursor: pointer;

  &:hover {
    .paintover-overlay {
      display: block;
    }
  }

  .author {
    position: absolute;
    padding: 0.5rem;
    bottom: 0;
    right: 0;
    color: white;
    background: rgba(0, 0, 0, 0.8);
  }

  img {
    vertical-align: bottom;
    max-width: 100%;
  }

  .paintover-overlay {
    position: absolute;
    display: none;
  }
}

.item__actions {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  z-index: 10;
}

.item__upload {
  &__label {
    font-size: 2rem;
    pointer-events: none;
  }
}

.item__action {
  padding: 0.5rem;
  background: color('background');
  color: color('text');
  border-radius: 4px;
  margin-left: 0.75rem;
  display: inline-flex;
}

.item__download {
  color: color('primary');

  &:active {
    background: color('primary');
    color: white;
  }
}

.item__critiqued {
  background: color('background');
  color: color('denotive', 'success');
}

::v-deep .drag-drop-area {
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 200ms ease-in-out;
  border: 4px solid color('secondary');
  &.entered {
    opacity: 1;
  }
}
</style>
